import {
  getInfo,
  login, 
  updatePassword,
  getAccessToken,
  getQrcode,
  getAdministratorList,
  getAdministratorInfo,
  getAdministratorAdd,
  getAdministratorUpdate,
  getAdministratorDisable,

} from "@/api/user";
import { setToken, removeToken } from "@/lib/local";
import { resetRouter } from "@/router";

const state = {
  token: "",
  info: {},
  type: "",
};
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INFO(state, info) {
    state.info = info;
  },
  SET_TYPE(state, data) {
    state.type = data;
  },
};
const actions = {
  // 登录
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      // 为spbprod保持一致，添加username字段
      const loginData = {
        ...userInfo,
        username: userInfo.mobile || userInfo.username
      };
      
      login(loginData).then(async (res) => {
        console.log(res)
        if (res && res.err_code === 0) {
          const { access_token, role_id } = res.data;
          
          // 按照spbprod的角色权限验证
          if (role_id !== 4 && role_id < 7) {
            alert('您没有权限登陆后台，请联系管理员！');
            return;
          }
          
          if (role_id >= 7 || role_id === 4) {
            let expires_data = new Date().getTime() + 12 * 60 * 60 * 1000; // 12小时
            
            setToken("jubao_admin", access_token, { expires: expires_data });
            setToken("admin_role", role_id, { expires: expires_data });
            
            commit("SET_TOKEN", access_token);
            commit("SET_TYPE", role_id);
            
            resolve(res);
          } else {
            alert('账号异常，请联系管理员！');
          }
        } else {
          alert('账号或密码错误，请重试！');
        }
      }).catch(error => {
        console.error('登录失败:', error);
        alert('网络错误，请刷新重试');
        reject(error);
      });
    });
  },

  // 获取 渠道用户信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then((res) => {
        if (res && res.err_code === 0) {
          commit("SET_INFO", res.data);
          resolve(res.data);
        } else {
          reject(new Error("获取管理员信息失败"));
        }
      }).catch(reject);
    });
  },

  // 退出登录
  logOut({ commit, dispatch }) {
    return new Promise((resolve) => {
      commit("SET_TOKEN", "");
      commit("SET_INFO", {});
      commit("SET_TYPE", "");

      removeToken("jubao_admin");
      removeToken("admin_role");

      resetRouter();

      dispatch("permission/resetRoutes", null, { root: true });

      dispatch("layout/delAllViews", null, { root: true });
      resolve();
    });
  },

  updatePassword(context, data) {
    return new Promise((resolve) => {
      updatePassword(data).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },

  getAccessToken(context, data) {
    return new Promise((resolve) => {
      getAccessToken(data).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
  getQrcode(context, data) {
    return new Promise((resolve) => {
      getQrcode(data).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },

  getAdministratorList(context, params) {
    return new Promise((resolve) => {
      getAdministratorList(params).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
  getAdministratorInfo(context, params) {
    return new Promise((resolve) => {
      getAdministratorInfo(params).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
  getAdministratorAdd(context, params) {
    return new Promise((resolve) => {
      getAdministratorAdd(params).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
  getAdministratorDisable(context, params) {
    return new Promise((resolve) => {
      getAdministratorDisable(params).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
  getAdministratorUpdate(context, params) {
    return new Promise((resolve) => {
      getAdministratorUpdate(params).then((res) => {
        if (res && res.err_code === 0) {
          resolve(res);
        }
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
